// extracted by mini-css-extract-plugin
export default {"CommandMenuDialogContent":"_CommandMenuDialogContent--mObai","Text":"_Text--t1qZI","Right":"_Right--dKoPk","Subtitle":"_Subtitle--GMfgk","Padding":"_Padding--eGTXh"};